import { ElementRef, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Component } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styles: [`
        .white_space_zhushi{
            white-space: pre-line;
        }
    `]
})

// 付款密码框 组件
export class TooltipComponent implements OnInit {
    @Input() text: string;
    constructor() {
    }

    ngOnInit(): void {

    }
}

